import { connect } from 'react-redux';
import { addIntegrationRequest, updateIntegrationRequest } from '../actions';
import {
    getVisibleIntegrationRequests,
    getHiddenRequestsByType,
    getIntegrationRequestsError,
    getIntegrationRequestsLoaded,
    getIntegrationRequestsLoading,
} from '../../selectors/partnerIntegration';
import IntegrationHomepage from '../components/IntegrationHomepage';

const mapStateToProps = state => ({
    requests: getVisibleIntegrationRequests(state),
    hiddenByType: getHiddenRequestsByType(state),
    loading: getIntegrationRequestsLoading(state),
    loaded: getIntegrationRequestsLoaded(state),
    error: getIntegrationRequestsError(state),
});

const mapDispatchToProps = dispatch => ({
    onAddRequest: request => dispatch(addIntegrationRequest(request)),
    onUpdateRequest: request => dispatch(updateIntegrationRequest(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationHomepage);
